import moment from 'moment'

/**
 * Z Formatted date.
 */
export const currentZDate = () => moment().toDate()
